// @ts-check
import React, { useState } from 'react';
import { Page, Utils } from 'ecrion-components';
import DocumentTitle from 'react-document-title';
import { useUser } from '../../context/UserContext';
import { useAsync } from 'react-async';
import * as publicInfoClient from '../../utils/publicInfoClient';
import { getFileFromCommunicationName } from '../../utils/portalFilesClient';
import PageNotFound from '../PageNotFound';
import Alert from '../Alert';
import Communication from '../Communication';

const parseSearchParams = (searchParams) => {
  if (!searchParams) return [];

  return Object.keys(searchParams).map((key) => ({
    name: key,
    value: searchParams[key],
  }));
};

const getPublicInfo = ([publicId, environment]) => {
  return publicInfoClient.get(publicId, environment);
};

const OnDemand = ({ match, history, location }) => {
  const [accessResponse, setAccessResponse] = useState({
    hasAccess: false,
    message: '',
  });
  const [accessToken, setAccessToken] = useState('');
  const [fileCategory, setFileCategory] = useState('');

  const url = Utils.url.parseUrl(location.search);
  const publicId = url.query.publicId;
  const communication = url.query.communication;
  const searchParams = Utils.url.getSearchParams(location.search);
  const parameters = parseSearchParams(searchParams);

  const urlEnvironment = match.params.environment;
  let userEnvironment = '';
  const user = useUser();
  if (user) userEnvironment = user.Environment;
  if (!publicId)
    if (decodeURIComponent(urlEnvironment) !== userEnvironment) {
      return <PageNotFound history={history} />;
    }

  const asyncPromise = useAsync({
    deferFn: getPublicInfo,
  });

  const getCategory = (file) => {
    if (file != null) {
      const categoryTag = file.Tags.find(
        (tag) => tag.Name === 'Portal Category'
      );
      if (categoryTag) {
        return categoryTag.Value.toLowerCase();
      }
    }
    return null;
  };

  const getPreviousLocation = () => {
    if (location.state && location.state.from) {
      return {
        ...location.state.from,
        state: {},
      };
    }
    return null;
  };

  const closeFile = () => {
    const previousLocation = getPreviousLocation();
    if (previousLocation) {
      history.push(previousLocation);
      return;
    }

    if (fileCategory) {
      history.push(`/${encodeURIComponent(userEnvironment)}/${fileCategory}`);
      return;
    }

    history.push(`/`);
  };

  React.useEffect(() => {
    if (publicId) asyncPromise.run(publicId, urlEnvironment);
    else
      getFileFromCommunicationName(url.query.communication, publicId)
        .then((file) => {
          const category = getCategory(file);
          category && setFileCategory(category);

          setAccessResponse({ hasAccess: true, message: '' });
        })
        .catch((err) => {
          setAccessResponse({
            hasAccess: false,
            message: Utils.getPrettyError(err),
          });
        });
  }, []);

  React.useEffect(() => {
    if (asyncPromise.data) {
      setAccessToken(asyncPromise.data.AccessToken);
      setAccessResponse({ hasAccess: true, message: '' });
    }

    if (asyncPromise.error) {
      setAccessResponse({
        hasAccess: false,
        message: 'The public link is no longer valid.',
      });
    }
  }, [asyncPromise]);

  return (
    <DocumentTitle title={`${communication} - Customer Portal`}>
      <div className="ondemand-wrapper">
        <Page.ToolBar
          color="navbar"
          icon={
            userEnvironment && {
              type: 'close',
              onClick: closeFile,
            }
          }
          leftChildren={communication}
        />
        {accessResponse.hasAccess ? (
          <Communication.Demand
            accessToken={accessToken}
            parameters={parameters}
            communication={communication}
          />
        ) : (
          accessResponse.message && <Alert>{accessResponse.message}</Alert>
        )}
      </div>
    </DocumentTitle>
  );
};

export default OnDemand;
